const gallery = (name = "gallery", label = "Gallery") => ({
  label,
  name,
  widget: "list",
  collapsed: true,
  fields: [
    {
      label: "Image",
      name: "image",
      widget: "image",
      default: "",
      required: true,
    },
  ],
});

export default gallery;
